import {Component, OnInit} from '@angular/core';
import {SessionService} from '../../core/session.service';
import {SessionQuery} from 'phd-akita-session';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {finalize} from 'rxjs/operators';

@Component({
  selector: 'ims-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.less']
})
export class LoginPageComponent implements OnInit {

  form: UntypedFormGroup;
  processing: boolean;

  constructor(private sess: SessionService,
              private qry: SessionQuery,
              fb: UntypedFormBuilder) {
    this.form = fb.group({
      userId: [null, Validators.required],
      password: [null, Validators.required],
    });
  }

  ngOnInit() {
  }

  signOn() {
    if (this.form.valid) {
      this.processing = true;
      const info = this.form.value;
      this.sess.auth(info.userId, info.password)
        .pipe(finalize(() => this.processing = false))
        .subscribe();
    } else {
      this.form.markAllAsTouched();
    }
  }

}
